module.exports = __webpack_public_path__ + "static/media/star-fill.951755ab.svg";